import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { EPaymentStatusConstant } from "../../../checkUrl/constants";
import { sessionStateMap } from "../../../checkUrl/persistence/map.dev";
import { Content } from "../../../getContent/Content";
import { redirect } from "../../../../../utils/redirect";
import { getWindow } from "../../../../../utils/window";
export var login = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var _sessionStateMap$save, _getWindow;
    var _Content$getInstance$, loginUrl, location, redirectUrl, params, fullLoginUrl, loginParams;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _Content$getInstance$ = Content.getInstance().getData(), loginUrl = _Content$getInstance$.loginUrl;
          (_sessionStateMap$save = sessionStateMap.saveSum) === null || _sessionStateMap$save === void 0 || _sessionStateMap$save.save();
          location = (_getWindow = getWindow()) === null || _getWindow === void 0 ? void 0 : _getWindow.location;
          if (location) {
            _context.next = 5;
            break;
          }
          return _context.abrupt("return");
        case 5:
          redirectUrl = new URL(location.pathname, location.origin);
          params = new URLSearchParams(_defineProperty({}, EPaymentStatusConstant.ContinuePaymentParameter, ''));
          redirectUrl.search = params.toString();
          fullLoginUrl = new URL(loginUrl, location.origin);
          loginParams = new URLSearchParams({
            returnUrl: redirectUrl.toString()
          });
          fullLoginUrl.search = loginParams.toString();
          _context.next = 13;
          return redirect(fullLoginUrl.toString(), getWindow());
        case 13:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function login() {
    return _ref.apply(this, arguments);
  };
}();